import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiCall from "../utils/apiCall";

function separateTransactions(transaction) {
  const modifiedTransactions = [];
  transaction.products.forEach((product) => {
    const newTransaction = {
      ...transaction,
      productDetails: { ...product },
    };
    delete newTransaction.products;
    modifiedTransactions.push(newTransaction);
  });
  return modifiedTransactions;
}

export const fetchTransactions = createAsyncThunk(
  "transactionsSlice/fetchTransactions",
  async (_, { getState, ...thunkApi }) => {
    const { token } = getState().auth;
    return await apiCall(
      `/transactions`,
      {
        headers: {
          Authorization: token,
        },
      },
      thunkApi,
    );
  },
);

export const addTransaction = createAsyncThunk(
  "transactionsSlice/addTransaction",
  async (transaction, { getState, ...thunkApi }) => {
    const { token } = getState().auth;
    return await apiCall(
      `/transactions`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(transaction),
      },
      thunkApi,
    );
  },
);

const transactionsSlice = createSlice({
  name: "transactionsSlice",
  initialState: {
    loading: false,
    error: null,
    transactions: [],
    detailedTransactions: [],
    soldTransactions: [],
    additionsTransactions: [],
    productTransactions: [],
    customerTransactions: [],
    invoiceNumberTransaction: null,
  },
  reducers: {
    getTransactionsByProductId: (state, action) => {
      state.productTransactions = state.detailedTransactions.filter(
        (transaction) => transaction.productDetails._id === action.payload,
      );
    },
    getCustomerTransactions: (state, action) => {
      state.customerTransactions = state.detailedTransactions.filter(
        (transaction) => transaction.customerDetails._id === action.payload,
      );
    },
    getInvoiceNumberTransaction: (state, action) => {
      state.invoiceNumberTransaction = state.transactions.find(
        (transaction) =>
          transaction.invoiceNumber === action.payload.invoiceNumber &&
          transaction.transactionType === action.payload.type,
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransactions.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.transactions = action.payload;
        state.soldTransactions = action.payload.filter(
          (transaction) => transaction.transactionType === "sell",
        );
        state.additionsTransactions = action.payload.filter(
          (transaction) => transaction.transactionType === "buy",
        );

        const detailedTransactions = [];
        action.payload.forEach((transaction) => {
          const modifiedTransactions = separateTransactions(transaction);
          detailedTransactions.push(...modifiedTransactions);
        });
        state.detailedTransactions = detailedTransactions;
      })
      .addCase(fetchTransactions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addTransaction.fulfilled, (state, action) => {
        if (action.payload.transactionType === "sell") {
          state.soldTransactions.unshift(action.payload);
        } else {
          state.additionsTransactions.unshift(action.payload);
        }
        state.transactions.unshift(action.payload);

        const modifiedTransactions = separateTransactions(action.payload);
        state.detailedTransactions.unshift(...modifiedTransactions);
      });
  },
});

export const {
  getTransactionsByProductId,
  getCustomerTransactions,
  getInvoiceNumberTransaction,
} = transactionsSlice.actions;
export default transactionsSlice.reducer;
